import { useEffect, useState, useCallback } from "react";

import { usePathname } from "next/navigation";

import { useAppDispatch } from "@/providers/store/hooks";
import { deleteClientError } from "@/providers/store/slices/app/slice";

export const useClearClientErrors = () => {
  const dispatch = useAppDispatch();
  const pathname = usePathname();

  const [externalTrigger, setExternalTrigger] = useState(false);

  const triggerClearErrors = useCallback(() => {
    setExternalTrigger(true);
  }, []);

  useEffect(() => {
    if (externalTrigger) {
      dispatch(deleteClientError(pathname));
      setExternalTrigger(false);
    }

    return () => {
      dispatch(deleteClientError(pathname));
    };
  }, [dispatch, externalTrigger, pathname]);

  return { triggerClearErrors };
};
